import { dateValidator } from 'helpers';
import {
  EMPLOYMENT_OPTIONS,
  motorcycleLicenseOptions,
  LICENSE_OPTIONS,
} from './options';

export enum DETAILS_SECTIONS {
  PERSONAL = 'Personal',
  FINANCES = 'Finances',
  ASSETS = 'Assets',
}

export const PERSONAL_DETAILS_FIELDS = [
  {
    key: 'address',
    label: 'My address',
    inputType: 'address',
    type: 'text',
    listDefaultKey: 'addresses',
    fullWidth: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    type: 'select',
    options: [
      { key: 'male', text: 'Male', value: 'male' },
      { key: 'female', text: 'Female', value: 'female' },
    ],
  },
  {
    key: 'dateOfBirth',
    label: 'Date of birth',
    type: 'birthday',
    arrow: true,
    validator: dateValidator,
  },
  {
    key: 'employment',
    label: 'Employment Status',
    type: 'select',
    options: EMPLOYMENT_OPTIONS,
  },

  {
    label: 'Licence Type',
    key: 'licenseType',
    type: 'select',
    options: LICENSE_OPTIONS,
  },

  {
    label: 'Years of driving experience',
    key: 'drivingExp',
    type: 'number',
  },
  {
    label: 'Motorcycle Licence Type',
    key: 'motorcycleLicenseType',
    type: 'select',
    options: motorcycleLicenseOptions,
  },
  {
    key: 'mortgage',
    label: 'Mortgage',
    type: 'select',
    options: [
      {
        key: 'mortgage1',
        text: 'Yes',
        value: true,
      },
      {
        key: 'mortgage2',
        text: 'No',
        value: false,
      },
    ],
  },
  {
    key: 'holidays',
    label: 'Travel',
    type: 'select',
    options: [
      {
        key: 'holidays1',
        text: 'Once in a blue moon',
        value: 'once',
      },
      {
        key: 'holidays2',
        text: 'Once a year',
        value: 'yearly',
      },
      {
        key: 'holidays3',
        text: 'More than once a year',
        value: 'frequently',
      },
    ],
  },
  {
    key: 'pet',
    label: 'Pets',
    type: 'select',
    options: [
      {
        key: 'pet1',
        text: 'None',
        value: 'none',
      },
      {
        key: 'pet2',
        text: 'Dog',
        value: 'dog',
      },
      {
        key: 'pet3',
        text: 'Cat',
        value: 'cat',
      },
      {
        key: 'pet4',
        text: 'Both',
        value: 'both',
      },
      {
        key: 'pet5',
        text: 'Others',
        value: 'others',
      },
    ],
  },
];

export const FINANCES_DETAILS_FIELDS = [
  {
    key: 'income',
    calcLabel: 'What is your yearly income?',
    label: 'Current income',
    inputType: 'number',
    type: 'number',
    prefix: '$',
  },
];

export const ASSETS_DETAILS_FIELDS = [
  {
    key: 'cars',
    label: 'Cars',
    type: 'select',
    options: [
      {
        key: 'cars1',
        text: 'Own',
        value: true,
      },
      {
        key: 'cars2',
        text: 'None',
        value: false,
      },
    ],
  },
  {
    key: 'homeOwnership',
    label: 'Home',
    type: 'select',
    options: [
      {
        key: 'rental',
        text: 'Rental',
        value: 'rental',
      },
      {
        key: 'own',
        text: 'My own',
        value: 'own',
      },
    ],
  },
  {
    key: 'landlord',
    label: 'Investment properties',
    type: 'select',
    options: [
      { key: '0', text: '0', value: '0' },
      { key: '1', text: '1', value: '1' },
      { key: '2', text: '2', value: '2' },
      { key: '3+', text: '3+', value: '3+' },
    ],
  },
];

export const USER_DETAILS_FIELDS = {
  [DETAILS_SECTIONS.PERSONAL]: PERSONAL_DETAILS_FIELDS,
  [DETAILS_SECTIONS.FINANCES]: FINANCES_DETAILS_FIELDS,
  [DETAILS_SECTIONS.ASSETS]: ASSETS_DETAILS_FIELDS,
};
